<template>
  <div>
    <img v-for="item in list"
    :src="`${base}assets/yoga/images/videos/${item.alias}.png`"
    :alt="item.label" :title="item.label" class="v-icon" :key="item.id">
  </div>
</template>

<script>
export default {
  name: `EquipItem`,
  props: {
    list: Array,
    base: String
  }
};
</script>

<style>
</style>
